import { Button, Classes, Intent } from '@blueprintjs/core';
import * as React from 'react';

import { addModelsToProject } from 'src/actions/projects/action-creators/addModelsToProject';
import { TEST_IDS } from 'src/constants/testIds';
import { connectionSelector } from 'src/selectors/connection';
import { isConnectedSelector } from 'src/selectors/isConnected';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

type ProjectModelDialogFooterProps = {
  databaseId: string | null;
  handleClose: () => void;
  models: string[];
};

export const ProjectModelDialogFooter: React.VFC<
  ProjectModelDialogFooterProps
> = ({ databaseId, handleClose, models }) => {
  const dispatch = useReduxDispatch();
  const { projectId } = useRouterParams();
  const connection = useReduxSelector(connectionSelector);
  const isConnected = useReduxSelector(isConnectedSelector);

  const isSubmitDisabled =
    !projectId ||
    !connection?.name ||
    !isConnected ||
    !databaseId ||
    !models.length;

  const handleSubmit = React.useCallback(() => {
    if (!projectId || !connection || !databaseId || !models.length) {
      return;
    }
    dispatch(
      addModelsToProject({
        projectId,
        connectionId: connection.id,
        databaseId,
        modelNames: models,
      })
    );
    handleClose();
  }, [connection, databaseId, dispatch, handleClose, models, projectId]);

  return (
    <div className={Classes.DIALOG_FOOTER}>
      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
        <Button
          data-testid={TEST_IDS.projectModelDialog.cancelButton}
          intent={Intent.PRIMARY}
          onClick={handleClose}
          outlined
          text={copy.components.projectModelDialog.cancelButton}
        />
        <Button
          data-testid={TEST_IDS.projectModelDialog.submitButton}
          disabled={isSubmitDisabled}
          intent={Intent.PRIMARY}
          onClick={handleSubmit}
          text={copy.components.projectModelDialog.addButton}
        />
      </div>
    </div>
  );
};
